import Vue from 'vue'
import * as types from 'store/mutation-types'

const actions = {
  loadCnBriefInfo({ commit, dispatch }, { symbol, market }) {
    const industry = () =>
      Vue.http.get(`~stock/market/plate/belonged/${symbol}`).then(resp => {
        if (resp.data.ret !== 0) {
          return []
        }
        return resp.data.items
      })

    const cnIntro = () =>
      Vue.http
        .get(`~stock/astock/symbol/publicity/${symbol}`, {
          params: {
            type: 'condition',
            version: 'v2'
          }
        })
        .then(resp => {
          if (resp.data.ret !== 0) {
            return {}
          }
          return resp.data
        })
    const cnFunds = () =>
      Vue.http
        .get(`~stock/astock/symbol/publicity_fund/${symbol}`)
        .then(resp => {
          if (resp.data.ret !== 0) {
            return {}
          }
          return resp.data.fund
        })

    return Promise.all([cnIntro(), industry(), cnFunds()]).then(
      ([intro, industry, funds]) => {
        return commit(types.LOAD_BRIEF_DATA, { intro, industry, funds })
      }
    )
  }
}

export default {
  actions
}
